// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e1e85ca8] .v-input__append-inner {\n  margin: 0 !important;\n}\n.custom-table[data-v-e1e85ca8] {\n  border: 1px solid #e8eef1;\n}\n.custom-table[data-v-e1e85ca8] th {\n  color: #424f62 !important;\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
